import { useState, useEffect } from 'react'
import { Keyboard, Platform, StyleProp, ViewStyle } from 'react-native'

export const useKeyboardVisibility = () => {
  const [isKeyboardVisible, setKeyboardVisible] = useState(false)
  const [keyboardHeight, setKeyboardHeight] = useState(0)

  useEffect(() => {
    const keyboardDidShowListener = Keyboard.addListener('keyboardDidShow', (event) => {
      setKeyboardVisible(true)
      setKeyboardHeight(event.endCoordinates.height)
    })
    const keyboardDidHideListener = Keyboard.addListener('keyboardDidHide', () => {
      setKeyboardVisible(false)
      setKeyboardHeight(0)
    })
    return () => {
      keyboardDidShowListener.remove()
      keyboardDidHideListener.remove()
    }
  }, [])

  const handleKeyboardPadding = (): StyleProp<ViewStyle> => {
    return {
      paddingBottom: Platform.OS === 'ios' && isKeyboardVisible ? keyboardHeight : 'auto',
    }
  }

  return { isKeyboardVisible, keyboardHeight, handleKeyboardPadding }
}
